
export default {
name: 'fullReduction',
components: {

},
data () {
return {
normalList: [],
channelList: []
}
},
methods: {
channelApply () {
this.$router.push({
path: '/channelApply'
})
},
getFullDiscoun (userType) {
this.$request.post('/order/listFullDiscount',{
userType,
}).then(data => {
if(data.code == 0){
if(userType == '0'){
data.obj.forEach((item, index) => {
if(item.discountFactor.toString().split(".").length == 1){
item.zhekou = item.discountFactor.toString().split(".")[0]
}else{
item.zhekou = item.discountFactor.toString().split(".")[1]
}
})
this.normalList = data.obj
}else if(userType == '1'){
data.obj.forEach((item, index) => {
if(item.discountFactor.toString().split(".").length == 1){
item.zhekou = item.discountFactor.toString().split(".")[0]
}else{
item.zhekou = item.discountFactor.toString().split(".")[1]
}
})
this.channelList = data.obj
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
created () {
this.getFullDiscoun('0')
this.getFullDiscoun('1')
},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/fullReduction/script.js